import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 10,
    top: 0,
    position: 'absolute',
  },
  title: {
    marginBottom: 20,
    color: theme.palette.colors.darkBlue,
  },
  rateBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  rateLink: {
    textDecorationLine: 'none',
  },
  rate: {
    textAlign: 'left',
    fontSize: '16vw',
    color: theme.palette.colors.teal,
    '&.h2': {
      textAlign: 'center',
    },
    [theme.breakpoints.up('mobile')]: {
      fontSize: 96,
    },
  },
  details: {
    marginTop: 20,
    marginBottom: 20,
    backgroundColor: theme.palette.colors.lightTealBackground,
    maxWidth: 800,
    borderRadius: 4,
    padding: [25, 10],
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
  },
  valueBox: {
    width: '25%',
  },
  value: {
    fontSize: 18,
    textAlign: 'center',
    fontWeight: 'bold',
    marginBottom: 7,
    [theme.breakpoints.up('mobile')]: {
      fontSize: 24,
    },
  },
  label: {
    textAlign: 'center',
    color: theme.palette.colors.blueGraySecondary,
  },
  disclousreBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  disclousre: {
    padding: 20,
    textAlign: 'center',
    color: theme.palette.colors.gray,
    maxWidth: 600,
  },
  navButton: {
    width: '100%',
    maxWidth: 300,
    boxShadow: 'rgb(38 166 154 / 80%) 0px 10px 40px -10px',
    marginBottom: 20,
  },
  navButtonApply: {
    width: '100%',
    borderWidth: 2,
    maxWidth: 300,
    borderColor: theme.palette.colors.teal,
    color: theme.palette.colors.teal,
    backgroundColor: theme.palette.colors.white,
    boxShadow: 'rgb(38 166 154 / 80%) 0px 10px 40px -10px',
    '&:hover': {
      borderColor: theme.palette.colors.teal,
      color: theme.palette.colors.teal,
      backgroundColor: theme.palette.colors.white,
    },
  },
  videoBlock: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  video: {
    border: 'none',
    borderRadius: theme.spacing(1),
    width: '90vw',
    height: '51vw',
    [theme.breakpoints.up('mobile')]: {
      width: 573,
      height: 322,
    },
  },
  videoTitle: {
    textAlign: 'center',
    marginTop: theme.spacing(3),
    color: theme.palette.colors.darkBlue,
  },
}));



// WEBPACK FOOTER //
// ./src/components/TodaysRates/useStyles.js